'use client';

import { Tab } from '@headlessui/react';
import Card from '@ui/Card';
import Typography from '@ui/Typography';
import clsx from 'clsx';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import React from 'react';

const tabs = [{ name: 'Activities', search: 'activities' }];

function WebViewSelector(props) {
  const { detailView } = props;
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const selected = searchParams.get('webView');
  const selectedIndex = tabs.findIndex((tab) => tab.search === selected);

  const router = useRouter();

  const onTabChange = (index) => {
    const params = new URLSearchParams(searchParams);
    params.delete('view');
    router.push(pathname + '?' + params.toString(), {
      scroll: false,
    });
    params.set('webView', tabs[index].search);
    router.push(pathname + '?' + params.toString(), {
      scroll: false,
    });
  };

  if (detailView !== 'overview') {
    return null;
  }

  return (
    <div className="flex w-full flex-col gap-2">
      <Tab.Group
        defaultIndex={selectedIndex === -1 ? 0 : selectedIndex}
        onChange={onTabChange}>
        <Tab.List className="flex w-full justify-start">
          {tabs.map((tab) => (
            <Tab
              key={tab.name}
              className={({ selected }) =>
                clsx(
                  'text-h4 flex-1 p-6 text-text-primary outline-none lg:p-8',
                  selected ? 'bg-white' : 'bg-transparent',
                )
              }>
              <Typography variant="h3" className="text-left">
                {tab.name}
              </Typography>
            </Tab>
          ))}
        </Tab.List>
      </Tab.Group>
    </div>
  );
}

export default WebViewSelector;
